import { apiGet, apiPost, apiRequest } from "./client";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

export const coursesApi = {
  tracks: () => apiGet("/api/courses/tracks"),
  theme: (track, themeSlug) => apiGet(`/api/courses/${track}/${themeSlug}`),
  chapter: (track, themeSlug, chapterSlug) =>
    apiGet(`/api/courses/${track}/${themeSlug}/${chapterSlug}`),
};

export const coursesAdminApi = {
  createTheme: (track, title) =>
    apiPost("/api/admin/courses/themes", { track, title }),
  updateTheme: (id, patch) =>
    apiRequest(`/api/admin/courses/themes/${id}`, {
      method: "PATCH",
      body: patch,
    }),
  deleteTheme: (id) =>
    apiRequest(`/api/admin/courses/themes/${id}`, { method: "DELETE" }),
  reorderThemes: (items) =>
    apiPost("/api/admin/courses/themes/reorder", { items }),

  createChapter: (themeId, title) =>
    apiPost("/api/admin/courses/chapters", { theme_id: themeId, title }),
  updateChapter: (id, patch) =>
    apiRequest(`/api/admin/courses/chapters/${id}`, {
      method: "PATCH",
      body: patch,
    }),
  deleteChapter: (id) =>
    apiRequest(`/api/admin/courses/chapters/${id}`, { method: "DELETE" }),
  reorderChapters: (items) =>
    apiPost("/api/admin/courses/chapters/reorder", { items }),

  uploadImage: async (file) => {
    const fd = new FormData();
    fd.append("file", file);
    const res = await fetch(`${API_BASE}/api/images/upload`, {
      method: "POST",
      credentials: "include",
      body: fd,
    });
    if (!res.ok) throw new Error(`Upload failed (${res.status})`);
    return res.json();
  },
};

export const imageUrl = (idOrUrl) => {
  if (!idOrUrl) return "";
  if (idOrUrl.startsWith("http") || idOrUrl.startsWith("/api/")) {
    return idOrUrl.startsWith("/api/") ? `${API_BASE}${idOrUrl}` : idOrUrl;
  }
  return `${API_BASE}/api/images/${idOrUrl}`;
};
